import React from 'react';

import Badge from '@adsk/alloy-react-badge';
import { SheetCollectionIcon } from '@adsk/alloy-react-icon';
import theme from '@adsk/alloy-react-theme';
import Tooltip, { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import { COLLECTION_DIVIDER_KEY } from '../helpers/consts';
import { isDefaultCollection as isDefault } from '../helpers/utils';
import { useTranslation } from '../i18n';

// Not standard alloy colors
const colors = {
  blue100: '#eef8fc',
  charcoal100: '#f6f6f6',
};

const styles = {
  listItem: {
    height: '36px',
    padding: '0 12px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    cursor: 'pointer',
  },
  divider: {
    display: 'block',
    height: '1px',
    margin: '8px 0 0 0',
    backgroundColor: colors.charcoal100,
  },
  tooltip: {
    overflow: 'hidden',
  },
};

const CollectionList = ({ list, selectedId, onClick }) => {
  const { t } = useTranslation();

  if (list.length === 0) return null;

  return (
    <div
      style={{
        width: '220px',
        overflow: 'auto',
        borderRight: '1px solid #eeeeee',
        flex: 'none',
      }}
    >
      <ul style={{ padding: '0', margin: '8px 0 0 0' }}>
        {list.map((option, index) => {
          const { id, name, selectedSheetsCount = 0 } = option;
          const isActive = id === selectedId;

          return id === COLLECTION_DIVIDER_KEY ? (
            <li key={`divider-${index}`} style={styles.divider} />
          ) : (
            <li
              key={id}
              style={{
                ...styles.listItem,
                backgroundColor: isActive ? colors.blue100 : theme.colors.white,
                ['&:hover']: {
                  backgroundColor: isActive
                    ? colors.blue100
                    : colors.charcoal100,
                },
              }}
              onClick={() => onClick(id, option)}
            >
              <div style={styles.tooltip}>
                {isDefault(option) ? (
                  <Tooltip content={t('DEFAULT_COLLECTION_NAME_TOOL_TIP')}>
                    {t('DEFAULT_COLLECTION_NAME')}
                  </Tooltip>
                ) : (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <SheetCollectionIcon
                      size={16}
                      style={{ marginRight: '8px', flexShrink: 0 }}
                    />
                    <OverflowTooltip>{name}</OverflowTooltip>
                  </div>
                )}
              </div>
              {selectedSheetsCount > 0 && (
                <Badge
                  style={{ backgroundColor: 'white' }}
                  variant={Badge.VARIANTS.OUTLINE}
                  size={Badge.SIZES.SMALL}
                >
                  {selectedSheetsCount}
                </Badge>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default CollectionList;
